import { Button } from "components/Button";
import styled from "styled-components";

export const Image = styled.div`
  display: flex;
  justify-content: center;

  margin-bottom: 28px;
  margin-top: 20px;
`;

export const CustomImage = styled.img`
  height: 56px;
`;

export const CustomButton = styled(Button)`
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

export const TextBtnYes = styled.p`
  color: #ffff;
`;